import { render, staticRenderFns } from "./BookRecord.vue?vue&type=template&id=11227066&scoped=true&"
import script from "./BookRecord.vue?vue&type=script&lang=js&"
export * from "./BookRecord.vue?vue&type=script&lang=js&"
import style0 from "../../less/book.less?vue&type=style&index=0&id=11227066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11227066",
  null
  
)

export default component.exports